import React, { useEffect, useState,useContext, useRef, use } from "react";
import { AppContext, UserContext } from "../../AppContextProvider";
import Popup from "reactjs-popup";
import { BrowserView,isBrowser,isMobile, MobileView } from "react-device-detect";
import {ButtonLoader} from "../utils/ButtonLoader";
import { useFetch } from "../api/FetchApiData";
import { MediaUrl } from "../utils/Media";
import Select from "react-select";
import default_bg from './icons/default_bg.webp';
import remove_icon from '../icons/remove.webp';
import edit_icon from '../icons/edit_.png';
import add_icon from './icons/add.webp';
import { useTranslation } from "react-i18next";



if (isMobile)
    import('./m_une.css').then(() => {});
else
    import('./une.css').then(() => {});



const SettingsPopUp = ({Une = {title:'',description:'',image:null,articles:[]}})=>
{
    const [loading,setLoading] = useState(false);
    const [une, setUne] = useState(Une);
    const [img,setImg] = useState(Une.image);
    const [meta,setMeta] = useState([]);
    const [articles,setArticles] = useState([]);
    const [DefaultSelectedArticles,setDefaultSelectedArticles] = useState([]);
    const [categories,setCategories] = useState([]);
    const fetchData = useFetch();
    const [notif,setNotif] = useState({text:"",color:"black"});
    const [UserState, setUserState] = useContext(UserContext);
    const [AppState, setAppState] = useContext(AppContext);
    const {t} = useTranslation();

    const saveUne = (close)=>
    {
        setLoading(true);
        let _une = une;
        if(!_une.hasOwnProperty('id'))
        {
            if(AppState.settings.lang !== 'fr')
            {setNotif({text:t("lang-ajout-une"),color:'orangered'});return;}
            let formdata = new FormData();
            if(_une.image instanceof Blob)
                formdata.append('image',_une.image,_une.image.name);
            else
                delete _une.image;
            console.log(_une);
            formdata.append('data',JSON.stringify(_une));
            fetchData.PostFormData(formdata,'une/').then((result)=>{
                if(result.result)
                {
                    setLoading(false);
                    setNotif({text:"Une ajouter avec succès ...",color:"green"});
                    setTimeout(()=>{setNotif({text:"",color:'black'});close();})
                }
                else
                {
                    setLoading(false);
                    setNotif({text:"Une erreur s'est produite. Votre demande n'a pas pu être executé.",color:"orangered"});
                }
            })

        }
        else
        {
            let formdata = new FormData();
            //delete _une.image;
            formdata.append('data',JSON.stringify(_une));
            console.log(_une);
            if(_une.image instanceof Blob)
                formdata.append('image',_une.image,_une.image.name);
            else
                delete _une.image;
            fetchData.PutFormData(formdata,`une/`).then((result)=>{
                console.log(result);
                if(result.result)                {
                    setLoading(false);
                    setNotif({text:"Une modifiée avec succès ...",color:"green"});
                    setTimeout(()=>{setNotif({text:"",color:'black'});close();})
                }
            });
        }
    }

    const updateArticles = (_articles)=>{
        
        const FormatArticle = (art)=>
        {
            return(
                <div style={{textAlign:'left',paddingLeft:'10px'}}>
                    <img src={MediaUrl(art.image)} style={{verticalAlign:'middle',width:'40px',height:'40px',borderRadius:'20px',display:'inline-block'}} />
                    <div style={{marginLeft:'20px',verticalAlign:'middle',display:'inline-block'}}>
                        <h5 style={{margin:'2px'}}>{art.title}</h5>
                        <span style={{color:'gray'}}>Reference : {art.id}</span>
                    </div>
                </div>
            );
        }
        let arr = [];
        let defaults = [];
        _articles.forEach(art=>{
            arr.push({label:FormatArticle(art),value:art.id});
            if(une.articles.includes(art.id))
                defaults.push({label:FormatArticle(art),value:art.id});
        
        });
        setArticles(arr);
        setDefaultSelectedArticles(defaults);
    }

    useEffect(()=>{
        if(!UserState.auth)
        {
            navigator('/')
        }
    },[UserState.auth])

    useEffect(()=>{
        var params = new URLSearchParams({
            meta:true
        });

        fetchData.GetData(`meta/articles/?${params}`).then((result)=>{
            if(result.result && result.meta.length > 0)
            {
                setMeta(result.meta);
                setCategories(Object.values(result.meta[0])[0]);
                updateArticles(result.articles);
            }
        });
    },[])

    useEffect(()=>{
        setUne(Une);
    },[Une?.id])

    useEffect(()=>{
        if(une.image===null || une.image===undefined)
            return
        let image_ = null;
        try{
            image_ = URL.createObjectURL(une.image);
        }
        catch{
            image_ = MediaUrl(une.image.image);
        }
        setImg(image_);
    },[une.image])

    const HandleSelectCategory = async (value)=>
    {    
        var params = new URLSearchParams({
            category:value,
            articles:JSON.stringify(Une.articles)
        })
        fetchData.GetData(`meta/articles/?${params}`).then((result)=>{
            if(result.result)
            {
                updateArticles(result.articles);
            }
        })
        
    }

    const HandleSelectArticle = (value, SelectedItems)=>{
        try{
            let arr = [];
            SelectedItems.forEach((item)=>{
                if(articles.includes(item))
                {
                    arr.push(item.value);
                }
            });
            setUne({...une,articles:arr});
        }        
        catch{
        }
    } 

    return(
        <Popup trigger={<img src={!!Une.id? edit_icon : add_icon} className="UneTrigger"/>}>
            {close=>(<div id="AddUne">
                <fieldset>
                    <p style={{color:notif.color}}>{notif.text}</p>
                    <div className="line">
                        <label className="une-label">{t('authentication.nom')} </label>
                        <input className="une-input" maxLength={28} value={une.title} onChange={(e)=>{setUne({...une,title:e.target.value});}} type="text" placeholder={t('authentication.nom')} />
                    </div>
                    <div className="line">
                        <label className="une-label">{t('produit.description')} </label>
                        <textarea maxLength={130} value={une.description} className="une-input" style={{height:'60px'}} onChange={(e)=>{setUne({...une,description:e.target.value});}} placeholder="Descriptif" />
                    </div>
                    <div className="line">
                        <label className="une-label">{t('une.articles')} </label>
                        <div className="une-div-input" style={{padding:'5px',border:'1px solid lightgray'}}>
                            <div style={{width:'100%'}}>
                                <div className="une-div-input">
                                    <label className="une-div-label" >{t('filters.rayon')}</label>
                                    <select className="une-input"  onChange={e=>{
                                            const cat = meta.find(m=>m.hasOwnProperty(e.target.value));
                                            if (!!cat)
                                                setCategories(cat[e.target.value]);
                                            else 
                                                setCategories([]);
                                        }}>  
                                        {meta.map((m)=>{
                                            return(Object.keys(m).map(key=>(<option key={key}>{key}</option>)));
                                        })}
                                    </select>
                                </div>
                                <div className="une-div-input">
                                    <label className="une-div-label">{t('filters.categories')}</label>
                                    <select className="une-input" onChange={e=>{HandleSelectCategory(e.target.value)}}>
                                        {categories.map(cat=>{
                                            return(Object.keys(cat).map(key=>(<option key={key} value={cat[key]}>{key}</option>)))
                                        })}
                                    </select>
                                </div>
                                <div className="une-div-input">
                                    <label className="une-div-label">{t('une.articles')}</label>
                                    <div className="une-input">
                                        <Select isClearable={true}
                                            isSearchable={true}
                                            value={articles.filter(a => Une.articles.includes(a.value))}
                                            defaultValue={DefaultSelectedArticles} 
                                            onChange={(value,action)=>{HandleSelectArticle(action,value)}} 
                                            loading={false} isMulti={true} 
                                            options={articles} 
                                            isMulti={true}
                                            />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="line" style={{minHeight:'40px'}}>
                        <label className="une-label">{t('ajout-produit.image')} : </label>
                        <input className="une-input" accept="image/png,image/jpeg,image/jpg" type='file' onChange={(e)=>{setUne({...Une,image:e.target.files[0]});}}/>
                    </div>
                    <div className="line" style={{textAlign:'center'}}>
                        <img style={{width:'30%'}} src={img} />
                    </div>
                    <div className="line" style={{textAlign:'center'}}>
                        <div style={{borderRadius:'5px',border:'none',padding:'10px 20px 10px 20px',width:'fit-content',backgroundColor:'lightgreen',display:'inline-block'}}>
                            <ButtonLoader loading={loading} style={{backGroundColor:'lightgreen'}} onSubmit={(e)=>{saveUne(()=>{close()});}} text={t('user-info.enregistrer')} />
                        </div>
                        <input type="button" onClick={close} value={t('ajout-produit.annuler')} style={{border:'none',padding:'10px 20px 10px 20px',width:'fit-content',margin:'5px',backgroundColor:'orangered',borderRadius:'5px',display:'inline-block'}} />
                    </div>
                </fieldset>
            </div>)}
        </Popup>
    );
}


export default function Une(props)
{
    const [TimerIsCanceled,SetisCanceled] = useState(false);
    const [limitDescrip,setLimitDescrip] = useState(270);
    const [AppState,setAppState] = useContext(AppContext);
    const [notif,setNotif] = useState({text:"",color:"orangered"});
    const [UserState,setUserState] = useContext(UserContext);
    const [items,setitems] = useState([]);
    const fetchData = useFetch();
    const {t} = useTranslation();
    let UneIndex = useRef(0);
    const [Une,setUne] = useState({
            image:{image:default_bg},
            is_default:true,
            color:'black',
            title: t("une.no-page"),
            description:t("une.no-page-info"),
        });
    const [Bg,setBg] = useState(default_bg);

    useEffect(()=>{
        const params = new URLSearchParams({une:'all'})
        if(isMobile)
            setLimitDescrip(100);
        fetchData.GetData(`une/?${params}`).then((result)=>{
            if(result.result && result.unes.length>0)
            {
                setitems(result.unes);
                const randomInt = Math.floor(Math.random() * (result.unes.length));
                setUne(result.unes[randomInt]);
            }
        })
    },[])

    useEffect(()=>{
        const params = new URLSearchParams({une:'all'})
        if(isMobile)
            setLimitDescrip(100);
        fetchData.GetData(`une/?${params}`).then((result)=>{
            if(result.result && result.unes.length>0)
            {
                setitems(result.unes);
                const randomInt = Math.floor(Math.random() * (result.unes.length));
                setUne(result.unes[randomInt]);
            }
        })
    },[AppState.settings.lang])

    const deleteUne = (close)=>    {
        fetchData.DeleteData({id:Une.id},`une/`).then((result)=>{
            if(result.result)            {
            }
        });
    }

    useEffect(()=>{
        const UneTimer  = setInterval(()=>{
            if(items.length>0)
            {
                UneIndex.current++;
                setUne(items[UneIndex.current % items.length]);
            }},30000);
        return ()=>{clearInterval(UneTimer)};
    },[])

    useEffect(()=>{
        if((!!Une.is_default && Une.is_default))
            setBg(default_bg);
        else
            setBg(MediaUrl(Une.image.image));
    },[Une])

    const SettingsTrigger = ()=>
    {
        return( <div id="InfoUne" style={{textAlign:'left'}}>
                    <div className="InfoText">
                        <div style={{margin:'auto',width:'100%',position:'relative',top:isMobile?'5%':'30%',transform:isMobile?'translateY(-5%)': 'translateY(-30%)'}}>
                            <h3 style={{color:'black',marginTop:'0px'}} id="Title">{Une.title} </h3>
                            <p style={{color:'black',maxWidth:'90%',textOverflow:'ellipsis',paddingTop:isMobile?'0px':'5px'}} id="Text">{Une.description.substring(0,limitDescrip)}</p>
                            {(isBrowser) && <div className="btn-une-switch" style={{margin:'auto'}}>
                                {
                                    items.map((item,index)=>{
                                    let size = isMobile?'15px':'21px';
                                    let border = 'none';
                                    if(item===Une)
                                    {border = '1px solid black';size= isMobile?'16px':'21px';}         
                                    return(<img key={index} onClick={e=>{setUne(item);}} src={MediaUrl(item.image.image)} className="UneIcon" style={{border:border,width:size,height:size,margin:'auto',marginRight:'5px'}}/>)})
                                }
                            </div>}
                        </div>
                        {(isBrowser) && <div style={{width:'100%',margin:'auto',textAlign:isMobile?'left':'center',position:'absolute',bottom:'25px'}}>
                            <div style={{marginBottom:'5px'}}>
                                <label style={{color:notif.color,marginRight:'10px'}}>{notif.text}</label>
                             </div>
                             <input onClick={e=>{
                                setNotif({text:t('une.lien'),color:'orangered'});
                            }} type="button" value={t('une.decouvrir')} style={{height:'25px',width:'50%',backgroundColor:'gold',borderRadius:'5px',border:'none',margin:'auto',fontSize:'x-small'}} />
                        </div>}
                    </div>
                </div>
            );
        
    }

    if(items.length > 0 || UserState.is_staff)
    {
        return(
            <div id="Une" style={{textAlign:'center',backgroundImage:"url("+Bg+")"}}>
                {SettingsTrigger()}
                {(isMobile) && <div className="btn-une-switch" style={{margin:'auto'}}>
                                {
                                    items.map((item,index)=>{
                                    let size = isMobile?'15px':'21px';
                                    let border = 'none';
                                    if(item===Une)
                                    {border = '1px solid black';size= isMobile?'16px':'21px';}         
                                    return(<img key={index} onClick={e=>{setUne(item);}} src={MediaUrl(item.image.image)} className="UneIcon" style={{border:border,width:size,height:size,margin:'auto',marginRight:'5px'}}/>)})
                                }
            </div>}
            {(UserState.is_staff) && <div className="Controls" >
                            <SettingsPopUp />
                            {(!!Une.id) && <SettingsPopUp Une={Une} />}
                            <img onClick={e=>{deleteUne()}} src={remove_icon} className="UneTrigger"/>
            </div>}
            {(isMobile) && 
            <div style={{width:'50%',margin:'auto',textAlign:isMobile?'right':'center',position:'absolute',bottom:'5px',right:'5px'}}>
                <div style={{marginBottom:'5px'}}>
                    <label style={{color:notif.color,marginRight:'10px'}}>{notif.text}</label>
                </div>
                <input onClick={e=>{
                                setNotif({text:t('une.lien'),color:'orangered'});
                            }} type="button" value={t('une.decouvrir')} style={{height:'25px',width:'50%',backgroundColor:'gold',borderRadius:'5px',border:'none',margin:'auto',fontSize:'x-small'}} />
            </div>}
        </div>
        );
    }
    
}